import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    NgxExtendedPdfViewerModule,
  ],
})
export class PdfViewerComponent {
  @Input() document: Blob;
  @Input() documentUrl: string;

  pdfLoaded() {
    // Rearrange toolbar so that the layout order is "left, center, right"
    const toolbarCenter = document.getElementsByTagName('pdf-zoom-toolbar')[0];
    const toolbarRight = document.getElementById('toolbarViewerRight');
    toolbarCenter.parentNode.insertBefore(toolbarCenter, toolbarRight);

    // Remove component's elements' specific tabindex. Reset to default
    this.removeTabindexByClass('toolbarButton');
    this.removeTabindexByClass('secondaryToolbarButton');
    this.removeTabindexByClass('toolbarField');

    // Add listeners to toolbar to support focusing on menu options when activated
    document.getElementById('secondaryToolbarToggle').onclick = () => {
      this.focusSecondaryToolbarButton();
    };

    document.getElementById('secondaryToolbarToggle').onkeypress = e => {
      if (e.code === 'Enter' || e.code === 'Space') {
        this.focusSecondaryToolbarButton();
      }
    };

    // Trap focus on menu
    const secondaryButtons = document.getElementsByClassName('secondaryToolbarButton');
    for (let i = 0; i < secondaryButtons.length; i++) {
      const secondaryButton = secondaryButtons[i];
      (secondaryButton as HTMLElement).onkeydown = e => {
        this.handleShiftTab(e);
        this.handleEscape(e);
      };
    }

    // Override last button to loop to first button
    (document.getElementById('secondaryToolbarButtonContainer')
      .lastChild as HTMLElement).onkeydown = e => {
      this.handleTab(e);
      this.handleEscape(e);
    };
  }

  private removeTabindexByClass(className: string) {
    const els = document.getElementsByClassName(className);
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      el.removeAttribute('tabindex');
    }
  }

  private focusSecondaryToolbarButton(focusLast: boolean = false) {
    const toolbarButtons = document
      .getElementById('secondaryToolbarButtonContainer')
      .getElementsByTagName('button');

    const toolbarButtonArray = this.convertToArray(toolbarButtons);

    if (focusLast) {
      toolbarButtonArray.reverse();
    }

    this.getFirstFocusableButton(toolbarButtonArray)?.focus();
  }

  private getFirstFocusableButton(buttons: HTMLButtonElement[]) {
    for (let i = 0; i < buttons.length; i++) {
      const toolbarButton = buttons[i];
      if (toolbarButton.classList.contains('invisible') || toolbarButton.disabled) {
        continue;
      }
      return toolbarButton;
    }
    return null;
  }

  private convertToArray(collection: HTMLCollectionOf<HTMLButtonElement>) {
    const toolbarButtonArray: HTMLButtonElement[] = [];
    for (let i = 0; i < collection.length; i++) {
      toolbarButtonArray.push(collection[i]);
    }
    return toolbarButtonArray;
  }

  private handleTab(e: KeyboardEvent) {
    if (e.code === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      this.focusSecondaryToolbarButton();
    }
  }

  private handleShiftTab(e: KeyboardEvent) {
    if (
      e.code === 'Tab' &&
      e.shiftKey &&
      (e.target as HTMLElement) ===
        this.getFirstFocusableButton(
          this.convertToArray(
            document
              .getElementById('secondaryToolbarButtonContainer')
              .getElementsByTagName('button'),
          ),
        )
    ) {
      e.preventDefault();
      this.focusSecondaryToolbarButton(true);
    }
  }

  private handleEscape(e: KeyboardEvent) {
    if (e.code === 'Escape') {
      document.getElementById('secondaryToolbarToggle').focus();
    }
  }
}
